import React from 'react'
import { Consumer } from '../../context';
import ImageCardLight from '../Cards/ImageCardLight';
import {v4 as uuid} from 'uuid';

function Paintings() {

    return (
        <Consumer>
            {(value) => {

                const {paintings} = value;

                return (
                    <div>
                        <div className="font-monospace text-center">
                            <div className="container-fluid pageHeading py-5" >
                                <div className="fs-1">
                                    Paintings
                                </div>
                            </div>

                            <div
                                className="container-fluid align-items-center  pageBackground"
                            >
                                <div className="container">
                                    <div className="row pb-5 px-5 font-monospace">
                                        {paintings.map((ill) => (
                                            <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                                <ImageCardLight
                                                    //section={paintings}
                                                    image={ill} />
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default Paintings;
